import gql from "graphql-tag";

const TOGGLE_MODAL = gql`
  mutation ToggleModal($modal: String) {
    toggleModal(modal: $modal) @client
  }
`;

export default TOGGLE_MODAL;
